import React from 'react';
import { Box, Typography } from '@mui/material';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import { GUARANTEES_APPLICATION_FILES_BLOCK_TITLE } from './constants.ts';
import ApplicationFilesContent from './ApplicationFilesContent.tsx';
import type { IGuaranteesApplicationFilesBlockProps } from './types.ts';

const GuaranteesApplicationFilesBlock: React.FC<IGuaranteesApplicationFilesBlockProps> = ({
  activeAction = null,
  fileTypes,
  isLoading = false,
  onDelete,
  onDownload,
  onRegenerate,
  onUpload,
  title = GUARANTEES_APPLICATION_FILES_BLOCK_TITLE,
}) => {
  const shouldRender = isLoading || fileTypes.length > 0;
  const content = (
    <ApplicationFilesContent
      fileTypes={fileTypes}
      isLoading={isLoading}
      activeAction={activeAction}
      onUpload={onUpload}
      onRegenerate={onRegenerate}
      onDownload={onDownload}
      onDelete={onDelete}
    />
  );

  return shouldRender ? (
    <Box sx={guaranteesClientPageStyles.statusFlowWrap}>
      <Box sx={guaranteesClientPageStyles.statusFlowHeader}>
        <Typography sx={guaranteesClientPageStyles.statusFlowTitle}>{title}</Typography>
      </Box>
      <Box sx={guaranteesClientPageStyles.statusFlowBody}>{content}</Box>
    </Box>
  ) : null;
};

export default GuaranteesApplicationFilesBlock;
